module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pz23-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#RR_22",
      "id": "CC_22"
    }
  }, [_vm._v(" Mrs. Lesch’s Lemon Bread")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "pz23-3"
    }
  }, [_c('i', [_vm._v(" Right on the money. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pABo"
    }
  }, [_c('b', [_vm._v(" 1 cup sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pA2LgO"
    }
  }, [_c('b', [_vm._v(" 5 tablespoons melted butter ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pALZc"
    }
  }, [_c('b', [_vm._v(" 2 eggs, beaten ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAnqA"
    }
  }, [_c('b', [_vm._v(" ½ cup milk ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAv9t"
    }
  }, [_c('b', [_vm._v(" 1½ cups all-purpose flour ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAnu"
    }
  }, [_c('b', [_vm._v(" ½ teaspoon salt ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAxqN"
    }
  }, [_c('b', [_vm._v(" 1 lemon rind, grated ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAved"
    }
  }, [_c('b', [_vm._v(" Juice of 1 lemon ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pA5ng"
    }
  }, [_c('b', [_vm._v(" ⅓ cup sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pATaQ"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("C")]), _vm._v("ream sugar, butter, and eggs. Add milk and dry ingredients alternately. Add lemon rind. Pour into a 9×5-inch (or two smaller pans) greased bread pans. Pull knife through batter to eliminate air bubbles. Bake at 350° for 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pAWOT"
    }
  }, [_vm._v("For topping, mix lemon juice and sugar; pour over hot bread. Let bread sit overnight. Can refrigerate up to 3 weeks. Can freeze.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pAQVJ"
    }
  }, [_vm._v("Makes 1 or 2 loaves.")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pAXsH"
    }
  }, [_c('i', [_vm._v("Karen Mol—Grand Rapids, Michigan")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "Akqc"
    }
  }, [_c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "pAOp8"
    }
  }, [_c('i', [_vm._v("Things get sweeter at the bakery when Millie arrives:")])]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "pAUHd"
    }
  }, [_c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "id": "AUHd"
    }
  }, [_c('tr', {
    attrs: {
      "id": "tr-AUHd-0"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AUHd-0-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("GOOBER:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AUHd-0-1"
    }
  }, [_vm._v("Hey, look. She’s going into Boysinger’s Bakery.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AUHd-1"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AUHd-1-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AUHd-1-1"
    }
  }, [_vm._v("Oh, yeah. I bet she’s gonna work there. Mr. Boysinger said he had a new girl coming in from Mt. Pilot.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AUHd-2"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AUHd-2-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("HOWARD:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AUHd-2-1"
    }
  }, [_vm._v("Hey, Andy. When’s the last time you had a cream bun?")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AUHd-3"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AUHd-3-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AUHd-3-1"
    }
  }, [_vm._v("Ohhh.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AUHd-4"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AUHd-4-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("HOWARD:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AUHd-4-1"
    }
  }, [_vm._v("Me too, you know. And I got a real craving for a cream bun right now. How ’bout you?")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AUHd-5"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AUHd-5-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AUHd-5-1"
    }
  }, [_vm._v("A little close to lunch, Howard.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AUHd-6"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AUHd-6-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("HOWARD:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AUHd-6-1"
    }
  }, [_vm._v("Oh, it’s my treat.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AUHd-7"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AUHd-7-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AUHd-7-1"
    }
  }, [_vm._v("Oh, I don’t know.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AUHd-8"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AUHd-8-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("HOWARD:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AUHd-8-1"
    }
  }, [_vm._v("Oh, come on, Andy. It’s my treat, my treat.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AUHd-9"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AUHd-9-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("ANDY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AUHd-9-1"
    }
  }, [_vm._v("Okay. I wouldn’t stand in between you and a cream bun.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AUHd-10"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AUHd-10-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("HOWARD:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AUHd-10-1"
    }
  }, [_vm._v("Well, good. How about you, Goober?")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AUHd-11"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AUHd-11-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("GOOBER:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AUHd-11-1"
    }
  }, [_vm._v("I have to go to work, but you owe me one.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b08f6592","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter22.vue
// module id = 129
// module chunks = 0